<div
  class="n-step-indicator n-step-indicator-state-{{
    state
  }} d-inline-flex align-items-center justify-content-center me-4 rounded-circle p-2h h-2-5rem w-2-5rem text-white"
  [ngClass]="{
    'bg-primary-300': state === 'edit',
    'bg-primary-400': selected,
    'bg-primary-500': state === 'number' && !selected,
    'bg-danger': state === 'error',
    'bg-success': state === 'done'
  }"
>
  <ng-container [ngSwitch]="state">
    <ng-container *ngSwitchCase="'edit'">
      <svg width="100%" height="100%" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21 1.00002L26 6.00002M0.5 28H28M7.00001 24L3.01649 23.9835L3.00001 20L19 3.99999L23 7.99999L7.00001 24Z"
          stroke="white"
        />
      </svg>
    </ng-container>
    <ng-container *ngSwitchCase="'error'">
      <svg width="100%" height="100%" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L13 13M25 25L13 13M13 13L25 1M13 13L1 25" stroke="white" />
      </svg>
    </ng-container>
    <ng-container *ngSwitchCase="'done'">
      <svg width="100%" height="100%" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 5.81482L6.28571 13L14 1" stroke="white" />
      </svg>
    </ng-container>
    <ng-container *ngSwitchCase="'number'">
      {{ index + 1 }}
    </ng-container>
  </ng-container>
</div>

<h4
  class="n-step-label mb-0"
  [class.n-step-label-active]="active"
  [class.n-step-label-selected]="selected"
  [class.n-step-label-error]="state === 'error'"
  [ngClass]="{ 'text-secondary-300': !selected }"
>
  <!-- If there is a label template, use it. -->
  <div class="n-step-text-label" *ngIf="templateLabel()">
    <ng-container [ngTemplateOutlet]="templateLabel()!.template"></ng-container>
  </div>
  <!-- If there is no label template, fall back to the text label. -->
  <div class="n-step-text-label" *ngIf="stringLabel()">{{ label }}</div>

  <div class="n-step-optional fs-8" *ngIf="optional && state !== 'error'" i18n>(opcjonalnie)</div>
  <div class="n-step-sub-label-error" *ngIf="state === 'error'">{{ errorMessage }}</div>
</h4>
